import * as React from 'react';

const SvgInfoCircleRed = (props) => (
  <svg
    width={20}
    height={20}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10 1.667c-4.592 0-8.333 3.741-8.333 8.333 0 4.591 3.741 8.333 8.333 8.333 4.592 0 8.333-3.741 8.333-8.333 0-4.592-3.741-8.333-8.333-8.333Zm-.625 5A.63.63 0 0 1 10 6.042a.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V6.666Zm1.392 6.983a.858.858 0 0 1-.175.275.96.96 0 0 1-.275.175.829.829 0 0 1-.317.066.829.829 0 0 1-.317-.066.961.961 0 0 1-.275-.175.86.86 0 0 1-.175-.275.83.83 0 0 1-.066-.317.83.83 0 0 1 .066-.316c.042-.1.1-.192.175-.275a.963.963 0 0 1 .275-.176.834.834 0 0 1 .634 0c.1.042.191.1.275.175a.96.96 0 0 1 .175.276c.041.1.066.208.066.316a.829.829 0 0 1-.066.317Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgInfoCircleRed;
